import { dateProvider } from '@utils';
import { TFunction } from 'i18next';

export const formatRelativeDate = (
  date: Date | string,
  t: TFunction<['DefaultTranslations' | 'ProblemReportsTranslations']>
): string => {
  const now = dateProvider.now();
  const targetDate = typeof date === 'string' ? new Date(date) : date;

  const diffMinutes = dateProvider.diff(targetDate, now, 'minutes');
  const diffHours = dateProvider.diff(targetDate, now, 'hours');
  const diffDays = dateProvider.diffCalendarDays(targetDate, now);
  const diffMonths = dateProvider.diff(targetDate, now, 'months');

  if (diffMinutes < 60) {
    return t('ProblemReportsTranslations:AGO_MINUTES', { count: Math.max(1, diffMinutes) });
  }

  if (diffHours < 24) {
    return t('ProblemReportsTranslations:AGO_HOURS', { count: diffHours });
  }

  if (diffDays < 365) {
    return t('ProblemReportsTranslations:AGO_DAYS', { count: diffDays });
  }

  return t('ProblemReportsTranslations:AGO_MONTHS', { count: diffMonths });
};
